module.exports = __webpack_public_path__ + "static/img/1-1.7f467b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/1-1.png
// module id = Lo1m
// module chunks = 0